ç<template>
  <div id='idDevExtreme'>
    <v-layout row wrap ma-0>
      <v-flex xs4>
        <v-select @change="fChangeFilters" v-model="dItemsFilters" :items="dArrayFilters" :label="$t('tipoCompVen')" hide-details chips multiple></v-select>
      </v-flex>
      <v-flex xs4 ml-5>
        <v-menu v-model="menu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="getFormattedDateIni" :label="$t('fechaInicial')" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="dFechaIni" @input="menu=false" :first-day-of-week="1" @change="fFormatDateIni"></v-date-picker>
        </v-menu>
        <v-menu v-model="menu2" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field :value="getFormattedDateFin" :label="$t('fechaFinal')" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
          </template>
          <v-date-picker v-model="dFechaFin" @input="menu2=false" :first-day-of-week="1"  @change="fFormatDateFin"></v-date-picker>
        </v-menu>  
      </v-flex>
      <v-flex xs12 class="py-2">
        <DxDataGrid ref="DatadecGrid" id="tableDevExtreme" :no-data-text="$t('noData')" :repaint-changes-only="true" :data-source="dCustomData" key-expr="rn" :remote-operations="true" @exporting="fExportGrid" :allow-column-reordering="true" :column-auto-width="true" :show-borders="true" >

          <DxColumnChooser :allow-search="true" :enabled="true" />
          <DxColumn v-if="dItemsFilters.includes(dArrayFilters[0])" :caption="$t('compras')" alignment="center">
            <DxColumn data-field="cAlmacen" :caption="$t('almacen')" />
            <DxColumn data-field="cFecha" :caption="$t('fecha')" data-type="date" format="dd-MM-yyyy" :allow-filtering="false" />
            <DxColumn data-field="cNumAlbaran" :caption="$t('numAlbaran')" :calculate-cell-value="fGetCNumeroAlbaran" :encode-html="false" />
            <DxColumn data-field="cProveedor" :caption="$t('proveedor')" :calculate-cell-value="fGetCProveedor" :encode-html="false" />
            <DxColumn data-field="cSucProveedor" :caption="$t('sucProveedor')" />
            <DxColumn data-field="cTransporte" :caption="$t('transporte')" />
            <DxColumn data-field="cMatricula" :caption="$t('matricula')" />
            <DxColumn data-field="cArticulo" :caption="$t('articulo')" :calculate-cell-value="fGetCArticulo" :encode-html="false" />
            <DxColumn data-field="cCantidad" :caption="$t('cantidad')" data-type="number" />
            <DxColumn data-field="cPrecio" :caption="$t('precio')" data-type="number" />
            <DxColumn data-field="cImporte" :caption="$t('importe')" data-type="number" />
            <DxColumn data-field="cPrecioMedio" :caption="$t('precioMedio')" data-type="number" />
            <DxColumn data-field="cAlbaranTte" :caption="$t('albaranTte')" data-type="number" :calculate-cell-value="fGetCAlbaranTte" :encode-html="false" />
            <DxColumn data-field="cTransportista" :caption="$t('transportista')" :calculate-cell-value="fGetCTransportista" :encode-html="false" />
            <DxColumn data-field="cImporteTte" :caption="$t('importeTte')" data-type="number" />
            <DxColumn data-field="cCosteTte" :caption="$t('costeTte')" data-type="number" />

          </DxColumn>
          <DxColumn v-if="dItemsFilters.includes(dArrayFilters[1])" :caption="$t('ventas')" alignment="center">
            <DxColumn data-field="vAlmacen" :caption="$t('almacen')" />
            <DxColumn data-field="vFecha" :caption="$t('fecha')" data-type="date" format="dd-MM-yyyy" :allow-filtering="false" />
            <DxColumn data-field="vNumAlbaran" :caption="$t('albaranTrans')" :calculate-cell-value="fGetVNumAlbaran" :encode-html="false" />
            <DxColumn data-field="vTicketPesada" :caption="$t('ticketPesada')" :calculate-cell-value="fGetVTicketPesada" :encode-html="false" />
            <DxColumn data-field="vCliente" :caption="$t('cliente')" :calculate-cell-value="fGetVCliente" :encode-html="false" />
            <DxColumn data-field="vSucCliente" :caption="$t('sucursal')" />
            <DxColumn data-field="vTransporte" :caption="$t('transporte')" />
            <DxColumn data-field="vMatricula" :caption="$t('matricula')" />
            <DxColumn data-field="vArticulo" :caption="$t('articulo')" :calculate-cell-value="fGetVArticulo" :encode-html="false" />
            <DxColumn data-field="vCantidad" :caption="$t('cantidad')" data-type="number" />
            <DxColumn data-field="vPrecio" :caption="$t('precio')" data-type="number" />
            <DxColumn data-field="vImporte" :caption="$t('importe')" data-type="number" />
            <DxColumn data-field="vPrecioMedio" :caption="$t('precioMedio')" data-type="number" />
            <DxColumn data-field="vAlbaranTte" :caption="$t('albaranTte')" data-type="number" :calculate-cell-value="fGetVAlbaranTte" :encode-html="false" />
            <DxColumn data-field="vTransportista" :caption="$t('transportista')" :calculate-cell-value="fGetVTransportista" :encode-html="false" />
            <DxColumn data-field="vImporteTte" :caption="$t('importeTte')" data-type="number" />
            <DxColumn data-field="vCosteTte" :caption="$t('costeTte')" data-type="number" />
          </DxColumn>
          <DxColumn v-if="dItemsFilters.includes(dArrayFilters[2])" :caption="$t('transitos')" alignment="center">
            <DxColumn data-field="tBeneficio" :caption="$t('beneficio')" />
          </DxColumn>
          <DxFilterRow :visible="true" :reset-operation-text="$t('reset')">
            <DxOperationDescriptions :greater-than-or-equal="$t('greaterThanOrEqual')" :starts-with="$t('startsWidth')" :equal="$t('equals')" :between="$t('between')" :contains="$t('contains')" :endsWith="$t('endsWith')" :greater-than="$t('greaterThan')" :less-than="$t('lessThan')" :less-than-or-equal="$t('lessThanOrEqual')" :not-contains="$t('notContains')" :not-equal="$t('notEqual')" />
          </DxFilterRow>
          <DxSearchPanel :visible="true" :placeholder="$t('searchPanel')" />
          <DxExport :enabled="true" />
          <DxScrolling column-rendering-mode="virtual" />
          <DxLoadPanel :enabled="true" :text="$t('cargandoContenido')" />

          <DxPaging :page-size="dNumRows" />
          <DxPager :visible="true" :info-text="'Pagina {0} de {1}. Total: {2}'" :allowed-page-sizes="[ 5, 10, 15 ]" :show-page-size-selector="pPagination.showPageSize" :show-info="pPagination.showText" :show-navigation-buttons="pPagination.showNavigation" />
        </DxDataGrid>
      </v-flex>
    </v-layout>

  </div>
</template>
<script>

import 'devextreme/dist/css/dx.light.css'
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxFilterRow,
  DxSearchPanel,
  DxExport,
  DxScrolling,
  DxPaging,
  DxLoadPanel,
  DxFilterPanel,
  DxPager,
  DxOperationDescriptions
} from 'devextreme-vue/data-grid'

import DxTagBox from 'devextreme-vue/tag-box'

// SERVICIOS

import SrvComprasVentas from '@/services/srv-compras-ventas'

import { Workbook } from 'exceljs'
import saveAs from 'file-saver'
import { exportDataGrid } from 'devextreme/excel_exporter'
import CustomStore from 'devextreme/data/custom_store'

export default {
  data () {
    return {
      searchText: '',
      dDataGrid: '',
      dDatos: [],
      dInfoText: '',
      dCustomData: [],
      dFilters: {},
      dNumRows: 10,
      dColumnChooser: {},
      dTypeCompra: 'C',
      dTypeVenta: '',
      dTypeTransito: '',
      dFechaActual: new Date().toLocaleDateString('en-GB'),
      dFechaAnterior: new Date().toLocaleDateString('en-GB'),
      dOrderObject: {
        'sortBy': 'cMatricula',
        'descending': 'ASC',
        'search': '',
        'searchCols': [
          'cAlmacen',
          'cFecha',
          'cNumAlbaran',
          'cProveedor',
          'cSucProveedor',
          'cMatricula',
          'cArticulo',
          'cTranportista',
          'cAlbaranTte',
          'vAlmacen',
          'vFecha',
          'vNumAlbaran',
          'vCliente',
          'vSucCliente',
          'vTransporte',
          'vMatricula',
          'vArticulo',
          'vCantidad',
          'vPrecio',
          'vImporte',
          'vPrecioMedio',
          'vAlbaranTte',
          'vTransportista',
          'vImporteTte',
          'vCosteTte'
        ]
      },
      dItemsFilters: ['Compras'],
      dArrayFilters: ['Compras', 'Ventas', 'Transitos'],
      dLoad: 0,
      dFechaIni: "",
      dFechaIniFormatted: '',
      dFechaFinFormatted: '',
      dFechaFin: "",
      menu2: false
    }
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxFilterRow,
    DxSearchPanel,
    DxExport,
    DxScrolling,
    DxPaging,
    DxLoadPanel,
    DxFilterPanel,
    DxPager,
    DxOperationDescriptions,
    DxTagBox
  },
  props: {
    pPagination: {
      type: Object,
      required: true,
      default: {
        'showPageSize': true,
        'showNavigation': true,
        'showText': true,
        'arrayRows': [ 5, 10, 15 ]
      }
    }
  },
  mounted () {
    this.dDataGrid = this.$refs['DatadecGrid'].instance
    this.dColumnChooser = this.$refs['columnChooser']
    this.dFechaIni = new Date()
    this.dFechaIni.setMonth(this.dFechaIni.getMonth() - 1)
    this.dFechaIni = this.dFechaIni.toISOString().substring(0, 10)
    this.dFechaFin = new Date().toISOString().substring(0, 10)

    //this.fFormatDateIni()
    //this.fFormatDateFin()
    
    // this.dFiltervalue = [['cFecha', '>=', this.dFechaAnterior], ['cFecha', '<=', this.dFechaActual]]
    this.fInitCustomStore()
  },
  methods: {
    fInitCustomStore () {
      this.dCustomData = new CustomStore({
        key: 'rn',
        load: (loadOptions) => {
          let offset = 1
          let descending = 'DESC'
          let page = 1
          let rowsPerPage = 10
          let sortBy = 'cMatricula'
          let query = ''
          
          if (loadOptions.filter !== undefined && loadOptions.filter[0].filterValue !== undefined) {
            this.dFechaAnterior = loadOptions.filter[0].filterValue[0]
            this.dFechaActual = loadOptions.filter[0].filterValue[1]
          } else if (loadOptions.filter !== undefined && loadOptions.filter.filterValue !== undefined) {
            this.dFechaAnterior = loadOptions.filter.filterValue[0]
            this.dFechaActual = loadOptions.filter.filterValue[1]
          }
          if (this.dLoad === 0) {
            loadOptions.filter = []
            this.fFormatDateIni()
            this.fFormatDateFin()
            // loadOptions.filter[0] = ['cFecha', '>=', new Date(this.dFechaAnterior.getFullYear() + '-' + (this.dFechaAnterior.getMonth() + 1) + '-' + this.dFechaAnterior.getDate())]
            // loadOptions.filter[1] = 'and'
            // loadOptions.filter[2] = ['cFecha', '<=', new Date(this.dFechaActual.getFullYear() + '-' + (this.dFechaActual.getMonth() + 1) + '-' + this.dFechaActual.getDate())]
          }
          this.dLoad++
          descending = (descending) ? 'DESC' : 'ASC'
          page = (page === undefined) ? 1 : page
          rowsPerPage = (loadOptions.take === undefined) ? rowsPerPage : loadOptions.take
          if (loadOptions.sort && loadOptions.sort !== null) {
            sortBy = ''
            loadOptions.sort.forEach(sorteado => {
              sortBy = sorteado.selector
              descending = (sorteado.desc) ? 'DESC' : 'ASC'
            })
          }
          offset = loadOptions.skip + 1
          query = this.fModFilter(loadOptions.filter)
         
          const payload = {
            empresa: this.$store.getters.getAutenticacion.empresa,
            transporte: '',
            numAlbaran: '',
            tipoCompra: this.dTypeCompra,
            tipoVenta: this.dTypeVenta,
            tipoTransito: this.dTypeTransito,
            fechaIni: this.dFechaIniFormatted,
            fechaFin: this.dFechaFinFormatted,
            offset: offset,
            numRows: rowsPerPage,
            orderBy: sortBy,
            order: descending,
            filter: loadOptions.filter,
            search: this.dOrderObject.search,
            searchCols: this.dOrderObject.searchCols,
            query: query
          }
          return SrvComprasVentas.getComprasVentas(payload).then(respuesta => {
            if (respuesta.data.statusCode === '200' && respuesta.data.infoMsg.code === 0) {
              let datos = []
              respuesta.data.dataRes.forEach(item => {
                datos.push({
                  'rn': item.rn,
                  'cAlmacen': item.cAlmacen,
                  'cFecha': item.cFecha,
                  'cNumAlbaran': item.cNumAlbaran,
                  'cProveedor': item.cProveedor,
                  'cSucProveedor': item.cSucProveedor,
                  'cTransporte': item.cTransporte,
                  'cMatricula': item.cMatricula,
                  'cArticulo': item.cArticulo,
                  'cCantidad': item.cCantidad,
                  'cPrecio': item.cPrecio,
                  'cImporte': item.cImporte,
                  'cPrecioMedio': item.cPrecioMedio,
                  'cAlbaranTte': item.cAlbaranTte,
                  'cTransportista': item.cTransportista,
                  'cImporteTte': item.cImporteTte,
                  'cCosteTte': item.cCosteTte,
                  'vAlmacen': item.vAlmacen,
                  'vFecha': item.vFecha,
                  'vNumAlbaran': item.vNumAlbaran,
                  'vTicketPesada': item.vTicketPesada,
                  'vCliente': item.vCliente,
                  'vSucCliente': item.vSucCliente,
                  'vTransporte': item.vTransporte,
                  'vMatricula': item.vMatricula,
                  'vArticulo': item.vArticulo,
                  'vCantidad': item.vCantidad,
                  'vPrecio': item.vPrecio,
                  'vImporte': item.vImporte,
                  'vPrecioMedio': item.vPrecioMedio,
                  'vAlbaranTte': item.vAlbaranTte,
                  'vTransportista': item.vTransportista,
                  'vCosteTte': item.vCosteTte,
                  'vImporteTte': item.vImporteTte,
                  'tIsTransito': item.tIsTransito,
                  'tBeneficio': item.vImporte - item.cImporte - item.cImporteTte - item.vImporteTte
                })
              })
              return {
                data: datos,
                totalCount: respuesta.data.numReg
              }
            }
          }).catch(error => {
            console.error(error)
            this.$emit('alert', 'error en la carga de la paquetería')
            return null
          })
        }
      })
    },
    fFormatDateFin() {
      const dateParts = this.dFechaFin.split('-');
      const formattedDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
      this.dFechaFinFormatted = formattedDate;

      this.$refs.DatadecGrid.instance.refresh();
    },
    fFormatDateIni() {
      const dateParts2 = this.dFechaIni.split('-');
      const formattedDate2 = `${dateParts2[2]}/${dateParts2[1]}/${dateParts2[0]}`;
      this.dFechaIniFormatted = formattedDate2;

      this.$refs.DatadecGrid.instance.refresh();
    },
    fAlert (msg) {
      this.$emit('alert', msg)
    },
    fSearch (busqueda) {
      switch (busqueda.name) {
        case 'searchPanel':
          this.dPrueba = this.dPrueba2
          break
        default:
      }
    },
    fChangeFilters (e) {
      this.dTypeCompra = ''
      this.dTypeVenta = ''
      this.dTypeTransito = ''
      e.forEach(filtro => {
        switch (filtro) {
          case 'Compras':
            this.dTypeCompra = 'C'
            break
          case 'Ventas':
            this.dTypeVenta = 'V'
            break
          case 'Transitos':
            this.dTypeTransito = 'T'
            break
        }
      })
      this.fInitCustomStore()
    },
    fGetReturnMessage (code, bloque, campo, valor) {
      return "<a onclick='parent.window.postMessage({\"form\":\"" + code + '","bloque":"' + bloque + '","campo":"' + campo + '","valor":"' + valor + "\", \"origen\":\"eInformes\"}, \"*\");'>" + valor + ' </a>'
    },
    fExportGrid (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet('Sales')
      exportDataGrid({
        worksheet: worksheet,
        component: e.component
      }).then(function () {
        workbook.xlsx.writeBuffer().then(function (buffer) {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Sales.xlsx')
        })
      })
      e.cancel = true
    },
    fCustomText (e) {
      return this.$t('filterMonth')
    },
    fChangeColumnName (column){
      //let newColumnName = ''
      switch (column) {
        case 'cAlmacen':
          column = '.almacen';
          break;
        case 'cFecha':
          column = '.fecha_entrada';
          break;
        case 'cNumAlbaran':
          column = '.albaran';
          break;
        case 'cProveedor':
          column = '.proveedor';
          break;  
        case 'cSucProveedor':
          column = '.sucursal';
          break;  
        case 'cTransporte':
          column = '';
          break;  
        case 'cMatricula':
          column = '.matricula';
          break;  
        case 'cArticulo':
          column = '.articulo';
          break;  
        case 'cCantidad':
          column = '.cantidad';
          break;  
        case 'cPrecio':
          column = '.precio';
          break;  
        case 'cImporte':
          column = '.precio*.cantidad';
          break;  
        case 'cPrecioMedio':
          column = '.precio_medio';
          break;  
        case 'cAlbaranTte':
          column = '.albaran_tte';
          break;  
        case 'cTransportista':
          column = '.transportista';
          break;  
        case 'cImporteTte':
          column = '.importe_tte';
          break;  
        case 'cCosteTte':
          column = '.coste_tte';
          break;  
        case 'vAlmacen':
          column = '.almacen';
          break;  
        case 'vFecha':
          column = '.fecha_albaran';
          break;  
        case 'vNumAlbaran':
          column = '.albaran';
          break;  
        case 'vCliente':
          column = '.cliente';
          break;  
        case 'vSucCliente':
          column = '.sucursal';
          break;  
        case 'vTransporte':
          column = '.transporte';
          break;  
        case 'vMatricula':
          column = '.matricula';
          break;  
        case 'vArticulo':
          column = '.articulo';
          break;  
        case 'vCantidad':
          column = '.cantidad';
          break;  
        case 'vPrecio':
          column = '.precio';
          break;  
        case 'vImporte':
          column = '.precio * .cantidad';
          break;  
        case 'vPrecioMedio':
          column = '.precio_medio';
          break;  
        case 'vAlbaranTte':
          column = '.albaran_tte';
          break;  
        case 'vTransportista':
          column = '.transportista';
          break;  
        case 'vCosteTte':
          column = '.coste_tte';
          break;
        case 'vImporteTte':
          column = '.importe_tte';
          break;  
      }
      return column;
    },
    fModFilter (filters) {
      let query = ''
      if (filters !== undefined) {
        if (filters.columnIndex !== undefined) {
          query += ' AND '
          if (Array.isArray(filters[0]) && Array.isArray(filters[2])) {
              query += this.fChangeColumnName(filters[0][0])
              query += this.fOperadorWithValue(filters[0][1], filters[0][2])
              query += ' AND '
              query += this.fChangeColumnName(filters[2][0])
              query += this.fOperadorWithValue(filters[2][1], filters[2][2])
          } else {
              query += this.fChangeColumnName(filters[0])
              query += this.fOperadorWithValue(filters[1], filters[2])
          }
        } else {
          query += ' AND '
          filters.forEach(filtro => {
            if (Array.isArray(filtro)) {
              if (Array.isArray(filtro[0]) && Array.isArray(filtro[2])) {
                  query += '' + this.fChangeColumnName(filtro[0][0]) + ''
                  query += this.fOperadorWithValue(filtro[0][1], filtro[0][2])
                  query += ' AND '
                  query += '' + this.fChangeColumnName(filtro[2][0]) + ''
                  query += this.fOperadorWithValue(filtro[2][1], filtro[2][2])
              } else {
                  query += this.fChangeColumnName(filtro[0])
                  query += this.fOperadorWithValue(filtro[1], filtro[2])
              }
            } else {
              query += ' AND '
            }
          })
        }
      }
      return query
    },
    fOperadorWithValue (operador, valor) {
      let date = null
      switch (operador) {
        case 'contains':
          return ' LIKE \'%' + valor + '%\' '
        case 'startswith':
          return ' LIKE \'%' + valor + '\''
        case 'endswith':
          return ' LIKE \'' + valor + '%\''
        case '<=':
          if (new Date(valor)) {
            date = new Date(valor)
          }
          if (date !== null && date instanceof Date) {
            return ' <= \'' + date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + '\''
          } else {
            return ' <= ' + valor
          }
        case '>=':

          if (new Date(valor)) {
            date = new Date(valor)
          }
          if (date !== null && date instanceof Date) {
            return ' >= \'' + date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + '\''
          } else {
            return ' >= ' + valor
          }
        case '<':

          if (new Date(valor)) {
            date = new Date(valor)
          }
          if (date !== null && date instanceof Date) {
            return ' < \'' + date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + '\''
          } else {
            return ' < ' + valor
          }
        case '>':

          if (new Date(valor)) {
            date = new Date(valor)
          }
          if (date !== null && date instanceof Date) {
            return ' > \'' + date.getDate() + '/' + (valor.getMonth() + 1) + '/' + date.getFullYear() + '\''
          } else {
            return ' > ' + valor
          }
        case '<>':

          if (new Date(valor)) {
            date = new Date(valor)
          }
          if (date !== null && date instanceof Date) {
            return ' <> \'' + date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear() + '\''
          } else {
            return ' <> ' + valor
          }
        case '=': 
            return ' = ' + valor + ' '
      }
    },
    // ENLACES DE CREACIÓN
    /* COMPRAS */
    fGetCNumeroAlbaran (rowData) {
      if (rowData.cNumAlbaran !== undefined && rowData.cNumAlbaran !== null) {
        if (rowData.tIsTransito === 'S') {
          return this.fGetReturnMessage('PCP594', 'B0', 'TRC_NUM_TRANSITO', rowData.cNumAlbaran)
        } else {
          return this.fGetReturnMessage('CMP695', 'CAR', 'CAR_NUMERO_ALBARAN', rowData.cNumAlbaran)
        }
      }

      return ''
    },
    fGetCArticulo (rowData) {
      if (rowData.cArticulo !== undefined && rowData.cArticulo !== null) {
        return this.fGetReturnMessage('ESM269', 'PRO', 'PRO_CODIGO_PRODUCTO', rowData.cArticulo)
      }
      return ''
    },
    fGetCProveedor (rowData) {
      if (rowData.cProveedor !== undefined && rowData.cProveedor !== null) {
        return this.fGetReturnMessage('MLM107', 'B0', 'PRO_COD_PROVEEDOR', rowData.cProveedor)
      }
      return ''
    },
    fGetCAlbaranTte (rowData) {
      if (rowData.cAlbaranTte !== undefined && rowData.cAlbaranTte !== null) {
        return this.fGetReturnMessage('CMM029', 'COC', 'COC_COD_ORDEN_COMPRA', rowData.cAlbaranTte)
      }
      return ''
    },
    fGetCTransportista (rowData) {
      if (rowData.cTransportista !== undefined && rowData.cTransportista !== null) {
        return this.fGetReturnMessage('MLM003', 'B0', 'AGT_NOMBRE', rowData.cTransportista)
      }
      return ''
    },
    /* VENTAS */
    fGetVNumAlbaran (rowData) {
      if (rowData.vNumAlbaran !== undefined && rowData.vNumAlbaran !== null && rowData.tIsTransito === 'S') {
        if (rowData.tIsTransito === 'S') {
          return this.fGetReturnMessage('PCP594', 'B0', 'TRC_NUM_TRANSITO', rowData.vNumAlbaran)
        } else {
          return this.fGetReturnMessage('ALP690', 'CAR', 'CAR_NUMERO_ALBARAN', rowData.vNumAlbaran)
        }
      }
      return ''
    },
    fGetVTicketPesada (rowData) {
      if (rowData.vTicketPesada !== undefined && rowData.vTicketPesada !== null) {
        return this.fGetReturnMessage('ALP690', 'B0', 'CPA_SECUENCIA_PESADAS', rowData.vTicketPesada)
      }
      return ''
    },
    fGetVCliente (rowData) {
      if (rowData.vCliente !== undefined && rowData.vCliente !== null) {
        return this.fGetReturnMessage('MLM024', 'B0', 'CLTE_COD_CLIENTE', rowData.vCliente)
      }
      return ''
    },
    fGetVArticulo (rowData) {
      if (rowData.vArticulo !== undefined && rowData.vArticulo !== null) {
        return this.fGetReturnMessage('ESM269', 'PRO', 'PRO_CODIGO_PRODUCTO', rowData.vArticulo)
      }
      return ''
    },
    fGetVAlbaranTte (rowData) {
      if (rowData.vAlbaranTte !== undefined && rowData.vAlbaranTte !== null) {
        return this.fGetReturnMessage('CMM029', 'COC', 'COC_COD_ORDEN_COMPRA', rowData.vAlbaranTte)
      }
      return ''
    },
    fGetVTransportista (rowData) {
      if (rowData.vTransportista !== undefined && rowData.vTransportista !== null) {
        return this.fGetReturnMessage('MLM003', 'B0', 'AGT_PROVEEDOR', rowData.vTransportista)
      }
      return ''
    }
  },
  watch: {
  },
  computed: {
		getFormattedDateIni(){
			let date = '';
			if(this.dFechaIni.length > 0){
				const dateSplitted = this.dFechaIni.split("-");
				date = `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}`;
			}
			return date;
		},
    getFormattedDateFin(){
			let date = '';
			if(this.dFechaFin.length > 0){
				const dateSplitted = this.dFechaFin.split("-");
				date = `${dateSplitted[2]}-${dateSplitted[1]}-${dateSplitted[0]}`;
			}
			return date;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components_datadec/DevExtremeTable.vue